import React, { Component } from 'react';
import { Button, Row, Col, Modal, Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { withTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone, solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';
import ChatsService from '../../controllers/ChatController';

class SendEmail extends Component {

    constructor(props) {
        super(props)

        this.state = {
            email: "",
            loading: false
        }

        this.setEmail = this.setEmail.bind(this);
        this.keyDown = this.keyDown.bind(this);
        this.sendEmail = this.sendEmail.bind(this);
    }

    setEmail(e) {
        e.preventDefault();
        this.setState({
            email: e.target.value
        });
    }

    keyDown = (e) => {
        if (e.keyCode === 13) {
            this.sendEmail(e);
        }
    }

    setLoading(value) {
        this.setState({
            loading: value
        });
    }

    sendEmail = e => {
        this.setLoading(true);
        ChatsService.sendEmail(this.state.email, this.props.guid, x => {
            this.setLoading(false);
            this.props.toggleModal();
        });
    }

    render() {
        return (
            <>
                <Modal show={this.props.show} onHide={this.props.toggleModal} onShow={this.showModal} size="lg">
                    <BlockUi tag="div" blocking={this.state.loading} color="#009ef7" message={this.props.t("pleasewait")}>
                        <Modal.Header >
                            <Modal.Title><FontAwesomeIcon icon={duotone("envelope")} /> {this.props.t("sendemail")}</Modal.Title>
                            <OverlayTrigger
                                placement="left"
                                delay={{ show: 250, hide: 400 }}
                                overlay={<Tooltip style={{ position: "fixed" }}>
                                    {this.props.t("close")}
                                </Tooltip>}>
                                <Button onClick={this.props.toggleModal} className='float-end'><FontAwesomeIcon icon={solid('xmark')} /></Button>
                            </OverlayTrigger>
                        </Modal.Header>
                        <Modal.Body>
                            <Row>
                                <Col>
                                    <Form>
                                        <Form.Group className="mb-4" controlId="fcemail">
                                            <Form.Label>{this.props.t("email")}</Form.Label>
                                            <Form.Control type="email" value={this.state.email} onChange={this.setEmail} onKeyDown={this.keyDown} autoFocus />
                                            <Form.Text className="text-muted">
                                            </Form.Text>
                                        </Form.Group>
                                    </Form>
                                </Col>
                            </Row>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="primary" onClick={this.sendEmail}>
                                <FontAwesomeIcon icon={duotone("paper-plane-top")} /> {this.props.t("send")}
                            </Button>
                        </Modal.Footer>
                    </BlockUi>
                </Modal>
            </>)
    }
}

export default withTranslation()(SendEmail);